import React from "react";
import { ChevronRight } from "lucide-react";

function renderNode(node, level, { selected, open, toggle, onPick }) {
  const hasKids = node.children.length > 0;
  const isOpen = !!open[node.id];
  const active = selected === node.slug;
  return (
    <li key={node.id}>
      <div className="flex items-center" style={{ paddingLeft: `${level * 14}px` }}>
        {hasKids ? (
          <button type="button" onClick={() => toggle(node.id)} className="h-6 w-5 flex items-center justify-center text-muted-foreground hover:text-accent"
            aria-label={`${isOpen ? "Collapse" : "Expand"} ${node.name}`} aria-expanded={isOpen} data-testid={`filter-cat-toggle-${node.slug}`}>
            <ChevronRight className={`h-3.5 w-3.5 transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`} strokeWidth={1.75} />
          </button>
        ) : <span className="w-5" />}
        <button type="button" onClick={() => onPick(node.slug)}
          className={`flex-1 text-left py-1 hover:text-accent transition-colors ${active ? "text-primary font-medium" : "text-muted-foreground"} ${level ? "text-[13px]" : ""}`}
          data-testid={`filter-cat-${node.slug}`}>
          {node.name}
        </button>
      </div>
      {hasKids && isOpen && (
        <ul>{node.children.map((k) => renderNode(k, level + 1, { selected, open, toggle, onPick }))}</ul>
      )}
    </li>
  );
}

export const CategoryTreeFilter = ({ tree, selected, open, toggle, onPick }) => (
  <ul className="text-sm" data-testid="category-tree">
    <li>
      <button type="button" onClick={() => onPick("")} className={`pl-5 py-1 hover:text-accent ${!selected ? "text-primary font-medium" : "text-muted-foreground"}`} data-testid="filter-cat-all">All</button>
    </li>
    {tree.map((n) => renderNode(n, 0, { selected, open, toggle, onPick }))}
  </ul>
);
